/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_Bank_HintInputs */

const vi_order_settlement_bank_hint = /** @type {(inputs: Order_Settlement_Bank_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách quét mã QR theo mã đơn để chuyển khoản (tự đối soát).`)
};

/**

* @param {Order_Settlement_Bank_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_bank_hint = /** @type {((inputs?: Order_Settlement_Bank_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_Bank_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_bank_hint(inputs)
});